"use client";

import { useDispatch, useSelector } from 'react-redux';
import {
  selectGuideposts,
  selectTrackerUnit,
  selectTrackerName,
  selectNotes,
  selectShowNotes,
  selectTrackerData, selectShowTracker, selectScheduleEvents, selectShowSchedule, selectCurrentWeekOffset
} from "../redux/selectors/roadmapV2.ts";
import {
  updateGuideposts,
  updateTrackerData,
  updateTrackerName,
  updateTrackerUnit,
  clearTrackerData,
  clearChecks,
  clearPractices,
  updateShowTracker,
  updateShowSchedule,
  incrementWeekOffset,
  decrementWeekOffset,
  updateCurrentWeekOffset,
  updateNotes,
  updateShowNotes,
} from "../redux/reducers/roadmapV2Slice.ts";
import {TrackerItem} from "../models/Tracker";


const usePlannerState = () => {
  const dispatch = useDispatch();

  const trackerData = useSelector(selectTrackerData);
  const guidePostData = useSelector(selectGuideposts);
  const trackerUnit = useSelector(selectTrackerUnit);
  const trackerName = useSelector(selectTrackerName);
  const showTracker = useSelector(selectShowTracker)
  const eventData = useSelector(selectScheduleEvents)
  const showSchedule = useSelector(selectShowSchedule)
  const currentWeekOffset = useSelector(selectCurrentWeekOffset)
  const notes = useSelector(selectNotes)
  const showNotes = useSelector(selectShowNotes)

  const setTrackerData = (pTrackerData: TrackerItem[]): void => {
    dispatch(updateTrackerData( pTrackerData ));
  };

  const setGuidepostData = (pGuideposts: TrackerItem[]): void => {
    dispatch(updateGuideposts(pGuideposts));
  };

  const setTrackerName = (pName: string): void => {
    dispatch(updateTrackerName(pName));
  };

  const setTrackerUnit = (pUnit: string): void => {
    dispatch(updateTrackerUnit(pUnit));
  };

  const setShowTracker = (pShow: boolean): void => {
    dispatch(updateShowTracker(pShow));
  };


  const setShowSchedule = (pShow: boolean): void => {
    dispatch(updateShowSchedule(pShow));
  };


  const setTrackerDataEmpty = () => {
    dispatch(clearTrackerData());
  }

  const setCheckDataEmpty = () => {
    dispatch(clearChecks());
  }

  const setPracticesEmpty = () => {
    dispatch(clearPractices());
  }

  const goToNextWeek = () => {
    dispatch(incrementWeekOffset());
  }

  const goToPreviousWeek = () => {
    dispatch(decrementWeekOffset());
  }

  const setWeekOffset = (offset: number) => {
    dispatch(updateCurrentWeekOffset(offset));
  }

  const setNotes = (notes: string) => {
    dispatch(updateNotes(notes));
  }

  const setShowNotes= (pShow: boolean): void => {
    dispatch(updateShowNotes(pShow));
  };

  return {
    trackerData,
    guidePostData,
    trackerUnit,
    trackerName,
    showTracker,
    eventData,
    showSchedule,
    currentWeekOffset,
    notes,
    showNotes,
    setShowSchedule,
    setShowTracker,
    setTrackerData,
    setGuidepostData,
    setTrackerName,
    setTrackerUnit,
    setTrackerDataEmpty,
    setCheckDataEmpty,
    setPracticesEmpty,
    goToNextWeek,
    goToPreviousWeek,
    setWeekOffset,
    setNotes,
    setShowNotes,
  };
};

export default usePlannerState;
